module.exports = __webpack_public_path__ + "static/media/referral-gift.d6ee5c94.svg";